export var REQUEST_FORGOT_PASSWORD = 'REQUEST_FORGOT_PASSWORD';
export var SUCCESS_FORGOT_PASSWORD = 'SUCCESS_FORGOT_PASSWORD';
export var FAILURE_FORGOT_PASSWORD = 'FAILURE_FORGOT_PASSWORD';